module.exports = __webpack_public_path__ + "img/encriptacao_ponto_a_ponto.2532f8ba.jpg";